import React, { useState,useRef } from "react";
import * as S from "./VideoTestimonials.styles";
import Slider from "react-slick";
import { reviewDetails } from "./mock";
import MyVideo from "./Video";

const MyVideoTestimonial = ({ isMobile }) => {
  const [activeItem, setActiveItem] = useState(false);
  const reviewKeys = reviewDetails;
  const slideRef = useRef(null);
  const settings = {
    className: `center-slider ${isMobile && "mobile-slider"}`,
    slidesToShow: isMobile ? 1.2 : 3,
    slidesToScroll: 1,
    centerMode: !isMobile,
    arrows: !isMobile,
    dots: true,
    speed: 1700,
    centerPadding: "0px",
    infinite: !isMobile,
    autoplaySpeed: 800,
    autoplay: false,
    lazyLoad:true,
  };

  return (
    <S.Container className={isMobile && "mobileContainer"}>
    <S.Heading className={isMobile && "mobileHeading"}>
        People Love myPartner
    </S.Heading>
    <S.SubHeading className={isMobile && "mobileSubHeading"}>
        See some of the stories.
    </S.SubHeading>

      <S.VideoContainer className={isMobile && "mobileVideoContainer"}>
        <Slider ref={slideRef} {...settings}>
          {reviewKeys.map((review, index) => {
            return (
              <S.CardContainer className={isMobile && "mobileCardContainer"} key={review.videoLink}>
                <S.CardWrapper className={isMobile && "mobileCardWrapper"}>
                  <MyVideo
                    index={index}
                    setActiveItem={setActiveItem}
                    activeItem={activeItem}
                    isMobile={isMobile}
                    videoSource={review.videoLink}
                    sliderRef={slideRef}
                  />  
                  <S.VideoInfo className={isMobile && "mobileVideoInfo"}>
                    <S.Seperator className={isMobile && "mobileSeperator"} />
                    <S.ReviewerName
                      className={isMobile && "mobileReviewerName"}
                    >
                      <S.ReviewrCompany
                        className={isMobile && "mobileReviewerCompany"}
                      >
                        {" "}
                        {review.agencyName}
                      </S.ReviewrCompany>
                    </S.ReviewerName>
            </S.VideoInfo>
                </S.CardWrapper>
              </S.CardContainer>
            );
          })}
        </Slider>
      </S.VideoContainer>
    </S.Container>
  );
};

export default MyVideoTestimonial;
